import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useRefreshInterval, REFRESH_INTERVALS } from '@internal/plugin-grafana-dashboard';

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: theme.spacing(2),
  },
  description: {
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    fontSize: 13,
  },
}));

export const RefreshIntervalCard = () => {
  const classes = useStyles();
  const { interval, setInterval } = useRefreshInterval();

  return (
    <Card className={classes.card}>
      <CardHeader title="Observability Refresh Rate" />
      <CardContent>
        <Typography className={classes.description}>
          How often the native observability dashboard auto-refreshes metrics, alerts, and logs.
        </Typography>
        <FormControl variant="outlined" size="small" style={{ minWidth: 160 }}>
          <Select
            value={interval}
            onChange={e => setInterval(e.target.value as number)}
          >
            {REFRESH_INTERVALS.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </CardContent>
    </Card>
  );
};
